function cov_16km7nxxrm() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/CenterFocusStrong.tsx";
  var hash = "d63325720010d489d4dd37bfcd6df74a3c8af429";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/CenterFocusStrong.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 59
        },
        end: {
          line: 4,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "d63325720010d489d4dd37bfcd6df74a3c8af429"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_16km7nxxrm = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_16km7nxxrm();
var Icon = (cov_16km7nxxrm().s[0]++, {
  name: 'center-focus-strong',
  svg: "<path d=\"M17 12c0-2.76-2.24-5-5-5s-5 2.24-5 5 2.24 5 5 5 5-2.24 5-5Zm-5 3c-1.65 0-3-1.35-3-3s1.35-3 3-3 3 1.35 3 3-1.35 3-3 3Zm-7 0H3v4c0 1.1.9 2 2 2h4v-2H5v-4ZM5 5h4V3H5c-1.1 0-2 .9-2 2v4h2V5Zm14-2h-4v2h4v4h2V5c0-1.1-.9-2-2-2Zm0 16h-4v2h4c1.1 0 2-.9 2-2v-4h-2v4Z\" fill=\"currentColor\"/>"
});
export default Icon;